require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ../~/angular-animate/index.js
// module id = 28
// module chunks = 0 1